"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingsResponseToJSON = exports.BookingsResponseFromJSONTyped = exports.BookingsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BookingsResponseFromJSON(json) {
    return BookingsResponseFromJSONTyped(json, false);
}
exports.BookingsResponseFromJSON = BookingsResponseFromJSON;
function BookingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, _1.BookingListFromJSON)(json['data']),
    };
}
exports.BookingsResponseFromJSONTyped = BookingsResponseFromJSONTyped;
function BookingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, _1.BookingListToJSON)(value.data),
    };
}
exports.BookingsResponseToJSON = BookingsResponseToJSON;
//# sourceMappingURL=BookingsResponse.js.map